module.exports = __webpack_public_path__ + "static/front-page-01-6e26ebb8c0380aceaba4b53d440ffac2.jpg";